module.exports = __webpack_public_path__ + "static/img/fz_dlb_ys.5054e36.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_dlb_ys.png
// module id = ccGC
// module chunks = 0